
export const FILTER_WAVEFORM_ANNOTATION_OPTIONS = [
    {
        "name": "Non-Sinus",
        "id": "Non-Sinus",
    },
    {
        "name": "No Annotation",
        "id": "None",
    },
    {
        "name": "First degree atrioventricular block",
        "id": "first degree atrioventricular block",
    },
    {
        "name": "Atrial fibrillation",
        "id": "atrial fibrillation",
    },
    {
        "name": "Bradycardia",
        "id": "bradycardia",
    },
    {
        "name": "Atrial flutter",
        "id": "atrial flutter",
    },
    {
        "name": "Complete right bundle branch block",
        "id": "complete right bundle branch block",
    },
    {
        "name": "Incomplete right bundle branch block",
        "id": "incomplete right bundle branch block",
    },
    {
        "name": "Left anterior fascicular block",
        "id": "left anterior fascicular block",
    },
    {
        "name": "Left axis deviation",
        "id": "left axis deviation",
    },
    {
        "name": "Left bundle branch block",
        "id": "left bundle branch block",
    },
    {
        "name": "Low QRS voltage",
        "id": "low QRS voltage",
    },
    {
        "name": "Non-specific intraventricular conduction delay",
        "id": "non-specific intraventricular conduction delay",
    },
    {
        "name": "Pacing rhythm",
        "id": "Pacing rhythm",
    },
    {
        "name": "Premature atrial contraction",
        "id": "Premature atrial contraction",
    },
    {
        "name": "Premature ventricular contractions",
        "id": "Premature ventricular contractions",
    },
    {
        "name": "Prolonged PR interval",
        "id": "Prolonged PR interval",
    },
    {
        "name": "Prolonged QT interval",
        "id": "Prolonged QT interval",
    },
    {
        "name": "Q wave abnormal",
        "id": "Q wave abnormal",
    },
    {
        "name": "Right axis deviation",
        "id": "Right axis deviation",
    },
    {
        "name": "Sinus arrhythmia",
        "id": "Sinus arrhythmia",
    },
    {
        "name": "Sinus bradycardia",
        "id": "Sinus bradycardia",
    },
    {
        "name": "Sinus rhythm",
        "id": "Sinus rhythm",
    },
    {
        "name": "Sinus tachycardia",
        "id": "Sinus tachycardia",
    },
    {
        "name": "T wave abnormal",
        "id": "T wave abnormal",
    },
    {
        "name": "T wave inversion",
        "id": "T wave inversion",
    },
    {
        "name": "Right bundle branch block (disorder)",
        "id": "Right bundle branch block (disorder)",
    },
    {
        "name": "Supraventricular premature beats",
        "id": "Supraventricular premature beats",
    },
    {
        "name": "Ventricular premature beats",
        "id": "Ventricular premature beats",
    },
];

export const FILTER_PERIOD_OPTIONS = [
    {
        "name": "1 sec",
        "id": "1s",
    },
    {
        "name": "1 min",
        "id": "1m",
    },
    {
        "name": "5 min",
        "id": "5m",
    },
    {
        "name": "1 hour",
        "id": "1h",
    },
];

export const FILTER_STATISTIC_OPTIONS = [
    {
        "name": "Average",
        "id": "avg",
    },
    {
        "name": "Median",
        "id": "p50",
    },
    {
        "name": "Min",
        "id": "min",
    },
    {
        "name": "Max",
        "id": "max",
    },
];

export const FILTER_REFERENCE_RANGE_OPTIONS = [
    {
        "name": "No Reference Range",
        "id": "none",
    },
    {
        "name": "Individual Range [5-95]",
        "id": "individual",
    },
    {
        "name": "Normal Range",
        "id": "normal",
    },
];

export const FILTER_ANNOTATION_OPTIONS = [
    "History",
    "Charted Vital Signs",
    "Medications",
    "Machine Learning Trends",
];

export const HIGHLIGHT_MAP_OPTIONS = [
    {
        "name": "Bed Usage",
        "id": "BED",
    },
    {
        "name": "Length of Stay",
        "id": "LOS",
    },
    {
        "name": "Dispo Risk",
        "id": "DISPO_RISK",
    },
];

export type FilterDateOptions = {
    dateOptionType: string,
    relativeStart: number,
    relativeStartScale: string,
    relativeEnd: number,
    relativeEndScale: string,
    absoluteStart: Date,
    absoluteEnd: Date,
}
